import { useRouteError } from 'react-router';

/**
 * Filet de sécurité affiché par react-router (errorElement) si une page
 * plante au chargement ou au rendu. Évite la « page blanche » : on montre
 * un message clair et un retour à l'accueil, dans le style du site.
 */
export function ErrorBoundary() {
  const error = useRouteError();

  if (import.meta.env.DEV) {
    // En développement seulement, on garde la trace en console pour déboguer.
    console.error('[ErrorBoundary]', error);
  }

  return (
    <div className="min-h-screen bg-brand-cream text-brand-ink flex items-center justify-center px-6 py-20">
      <div className="text-center max-w-md">
        <p className="font-hand text-brand-pink text-3xl md:text-4xl mb-4">Oups…</p>
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Une petite erreur s'est glissée ici
        </h1>
        <p className="text-brand-soft-ink mb-8">
          Quelque chose n'a pas pu s'afficher correctement. Vous pouvez réessayer
          ou revenir à l'accueil.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-6 py-3 rounded-full border-2 border-brand-pink text-brand-pink font-medium hover:bg-brand-pink hover:text-white transition-colors"
          >
            Réessayer
          </button>
          <a
            href="/"
            className="px-6 py-3 rounded-full bg-brand-pink text-white font-medium shadow-lg hover:opacity-90 transition-opacity"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
}
